class CartWatcher {
  init() {
    this.observeCartChanges();
  }

  async fetchCart() {
    const response = await fetch("/cart.js");
    return response.json();
  }

  async emitCartChanges() {
    const cart = await this.fetchCart();
    const hasGiftBox = cart.items.some((item) => item.title === "Gift Box");

    if (hasGiftBox) {
      document.querySelector(".giftwrap_container").style.display = "none";
    } else {
      document.querySelector(".giftwrap_container").style.display = "block";
    }

    console.log("Cart Items:");
    cart.items.forEach((item, index) => {
      console.log(`${index + 1}. ${item.title} (Quantity: ${item.quantity})`);
    });
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ["xmlhttprequest", "fetch"].includes(
          entry.initiatorType
        );
        const isCartChangeRequest = /\/cart\//.test(entry.name);

        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });

    cartObserver.observe({ entryTypes: ["resource"] });
  }
}

const myCartWatcher = new CartWatcher();
myCartWatcher.init();
